import type {AudienceListsActions} from 'src/action-creators/audience-lists';
import type {AudienceListTableEntry} from 'src/types/audience-list';

import {
  RECEIVE_LISTS,
  PUBLISH_LISTS,
  RECEIVE_LIST_UPDATE,
  REFETCH,
  RESET_LIST_PAGE_STATE,
} from 'src/action-creators/audience-lists';


export type State = {
  lists: AudienceListTableEntry[];
  total: number;
  refetch: boolean;
  //flag to communicate with list.jsx componeent
  //so that it resets its state
  resetListPageState: boolean;
  listsMap: Map<number, AudienceListTableEntry[]>;
};

const initialState = {
  lists: [],
  total: 0,
  refetch: false,
  resetListPageState: false,
  listsMap: new Map(),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly lists: readonly []; readonly total: 0; readonly refetch: false; readonly resetListPageState: false; readonly listsMap: Map<any, any>; }' is not assignable to type 'State'.
  state: State | null | undefined = initialState,
  action: AudienceListsActions,
): State => {
  switch (action.type) {
    case RECEIVE_LISTS: {
      const {lists, total, pageNumber, isNewList} = action.payload;
      // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
      const tempListsMap = isNewList ? new Map() : new Map(state.listsMap);

      // @ts-expect-error - TS2322 - Type '{ lists: Partial<AudienceList & { lastUserActionAt: string; hasDifferentSecurityGroup: boolean; metadata: AudienceListMetadata; standardRelatedEntities: string[]; lastUserAction: string; }>[]; total: number; listsMap: Map<...>; refetch?: boolean | undefined; resetListPageState?: boolean | undefined; }' is not assignable to type 'State'.
      return {
        ...state,
        lists: action.payload.lists,
        total: action.payload.total,
        listsMap: tempListsMap.set(pageNumber, lists),
      };
    }
    case RECEIVE_LIST_UPDATE: {
      const {id, name, status} = action.payload;
      // @ts-expect-error - TS2322 - Type '{ lists: Partial<AudienceList & { lastUserActionAt: string; hasDifferentSecurityGroup: boolean; metadata: AudienceListMetadata; standardRelatedEntities: string[]; lastUserAction: string; }>[]; total?: number | undefined; refetch?: boolean | undefined; resetListPageState?: boolean | undefined; listsMap?: Map<...> | u...' is not assignable to type 'State'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        lists: state.lists.map((list) => {
          if (list.id === id) {
            return {...list, name, status};
          }
          return list;
        }),
      };
    }
    case PUBLISH_LISTS: {
      const publishedLists = new Set(action.payload);
      // @ts-expect-error - TS2322 - Type '{ lists: Partial<AudienceList & { lastUserActionAt: string; hasDifferentSecurityGroup: boolean; metadata: AudienceListMetadata; standardRelatedEntities: string[]; lastUserAction: string; }>[]; total?: number | undefined; refetch?: boolean | undefined; resetListPageState?: boolean | undefined; listsMap?: Map<...> | u...' is not assignable to type 'State'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        lists: state.lists.map((list) => {
          // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
          if (publishedLists.has(list.id)) {
            return {...list, status: 'published'};
          } else {
            return list;
          }
        }),
      };
    }
    case REFETCH: {
      // @ts-expect-error - TS2322 - Type '{ refetch: boolean; lists?: Partial<AudienceList & { lastUserActionAt: string; hasDifferentSecurityGroup: boolean; metadata: AudienceListMetadata; standardRelatedEntities: string[]; lastUserAction: string; }>[] | undefined; total?: number | undefined; resetListPageState?: boolean | undefined; listsMap?: Map<...> | u...' is not assignable to type 'State'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        refetch: !state.refetch,
      };
    }
    case RESET_LIST_PAGE_STATE: {
      // @ts-expect-error - TS2322 - Type '{ resetListPageState: boolean; lists?: Partial<AudienceList & { lastUserActionAt: string; hasDifferentSecurityGroup: boolean; metadata: AudienceListMetadata; standardRelatedEntities: string[]; lastUserAction: string; }>[] | undefined; total?: number | undefined; refetch?: boolean | undefined; listsMap?: Map<...> | u...' is not assignable to type 'State'.
      return {
        ...state,
        resetListPageState: action.payload,
      };
    }
  }

  // @ts-expect-error - TS2322 - Type 'State | null' is not assignable to type 'State'.
  return state;
};
